import styled from 'styled-components';

import { StyledTextField } from 'app/components/styles';

export const StyledOptions = styled.span<{ option: string }>`
  display: flex;
  align-content: flex-end;

  width: 100%;
  margin: 6px 0;

  ::before {
    font-family: Erply-Icons, serif;
    content: ${({ option }) => option};
    font-size: 1.7rem;
    color: ${({ theme: { shade } }) => shade['500']};
    margin-right: 1.25rem;
  }
`;
export const StyledListBox = styled.ul`
  li:nth-child(5) {
    position: relative;
    ::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 15px;
      right: 15px;
      height: 1px;
      border-bottom: 1px solid ${({ theme: { shade } }) => shade['100']};
    }
  }
  li {
    padding-bottom: 0;
    padding-top: 0;
  }
`;
export const STextField = styled(StyledTextField)`
  .MuiInputAdornment-positionStart {
    margin-right: 0;
  }
  &&& {
    input {
      padding: 0.3rem 0;
      margin: auto 0;
    }
  }
`;
